import * as React from "react";
import { CoordinateData, UIStateAction } from "./UIState";

export function TileSlot(props: {
    tile?: React.JSX.Element | null;
    location: CoordinateData;
    uiDispatch: (x: UIStateAction) => void;
}): React.JSX.Element {
    let isDraggable = props.tile != null;

    function onDragStart(e: React.DragEvent<HTMLDivElement>) {
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData(
            "wordGrid/coords",
            JSON.stringify(props.location),
        );
    }

    function onDrop(e: React.DragEvent<HTMLDivElement>) {
        const startLocation: CoordinateData = JSON.parse(
            e.dataTransfer.getData("wordGrid/coords"),
        );
        const thisLocation = props.location;

        props.uiDispatch({
            $type: "DRAG",
            from: startLocation,
            to: thisLocation,
        });
    }

    let className = "tileSpot";
    if (props.location.location === "GRID") {
        className += " ephemeral";
    }

    return (
        <div
            className={className}
            draggable={isDraggable}
            onDragStart={onDragStart}
            onDrop={onDrop}
            onClick={() => {
                props.uiDispatch({ $type: "CLICK", location: props.location });
            }}
            onDragOver={(e) => {
                e.preventDefault();
            }}
        >
            {props.tile}
        </div>
    );
}
